/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              SindingCo.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var SindingCo = SindingCo || {};

$(function () {
    // Only include Novicell functions that you use!
    svg4everybody();
    novicell.responsive.init();
    if($('#map-canvas').length){ novicell.map.init(); }
    
    // novicell.adjustFigureImage.init();
    // novicell.lazyload.content();
    // novicell.lazyload.image();
});

/*
 *  Use the following if needed
 */

// Window load
// $(window).load(function(e){
//     // call functions here
// }); // Window load

// // Window resize
// $(window).resize(function(e){
//     // call functions here
// }); // Window resize

// // Window scroll
// $(window).scroll(function(e){
//     // call functions here
// }); // Window scroll
if ($(".contourMessageOnSubmit").length > 0) {
    $("html, body").animate({
        scrollTop: $(".contourMessageOnSubmit").offset().top - 150
    }, 500);
    document.onkeydown = function (event) {
        if (window.event) {
            event.preventDefault();
        }
    }
}

setTimeout(function() {
    var mainNav = document.getElementById('js-main-nav');
    if(mainNav) {
        var widthOfMainNav = mainNav.offsetWidth;
        console.log(widthOfMainNav);
        
        if(widthOfMainNav > 940) {
            console.log("set top: 0 on serviceNav");
            document.getElementById('js-service-nav').style.top = "0px";
        }
    }
}, 100);